/* tslint:disable */
import { MinMax } from './min-max';

/**
 */
export class ViewMinMaxProduction {
    mmDaily?: MinMax;
    mmWeekly?: MinMax;
    mmAnnual?: MinMax;
    mmPerDay?: MinMax;
    mmFactory?: MinMax;
    mmHumidity?: MinMax;
    mmAverage?: MinMax;
    mmProdFlow?: MinMax;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/view-min-max-production.ts